const { STATUS, CHECK_ID } = require('../constants');
const { SDK_FOPS } = require('../../variables');

// Ottu PG methods from local config (flow === 'ottu_pg'). Shared with ottuPg.js.
function ottuPgMethods(ctx) {
  const methods = (ctx && ctx.paymentMethods) || [];
  return methods.filter((m) => m && m.flow === SDK_FOPS.OTTU_PG);
}

function runJazzCheck(ctx, apiConfig) {
  const jazz = ottuPgMethods(ctx).filter((m) => m.use_as_jazz_sdk === true);
  const evidence = {
    useAsJazzSdk: jazz.length > 0,
    jazzMethodCount: jazz.length,
    jazzMethods: jazz.map((m) => m.code),
    apiAvailable: !!apiConfig,
  };
  if (!jazz.length) {
    return { id: CHECK_ID.JAZZ, status: STATUS.INFO, detail: 'Jazz SDK is not configured for this merchant', evidence };
  }
  return { id: CHECK_ID.JAZZ, status: STATUS.PASS, detail: 'Jazz SDK is enabled (use_as_jazz_sdk) on an Ottu PG method', evidence };
}

module.exports = { runJazzCheck, ottuPgMethods };
